module.exports = __webpack_public_path__ + "img/cloud03.b362ed05.png";